// Webpack Imports
import Collapse from 'bootstrap/js/dist/collapse'; // for collapase same rubrique
import Dropdown from 'bootstrap/js/dist/dropdown'; // for the menu
import Modal from 'bootstrap/js/dist/modal';
import Popover from 'bootstrap/js/dist/popover';
import { Backdrop } from "exports-loader?exports=Backdrop!bootstrap/js/src/util/backdrop";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// import MatchHeight from '@tannerhodges/match-height';
import MatchHeight from './js-modules/matchHeigth';  // code modify caused issues https://github.com/tannerhodges/match-height/issues/24

import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.

// JS modules
import reportWindowSize from "./js-modules/reportWindowSize";
import { AjaxPost, AjaxSearch } from "./js-modules/ajax";
import menuSticky from "./js-modules/menu-sticky";
import menuToggle from "./js-modules/menu-toggle";
import { searchToggle } from "./js-modules/search-toggle";
import { stickyScrollElement } from "./js-modules/stickyScrollElement";
import { hideSticky } from "./js-modules/hideSticky";
import sidebarItemPosition from "./js-modules/sidebarItem";



document.querySelector("html").classList.remove('no-js');


window.addEventListener("DOMContentLoaded", function () {
	reportWindowSize();
	AjaxPost();
	AjaxSearch();
	menuToggle();
	menuSticky();
	new searchToggle('.toggler-search-js');
	



	//move backdrop modal on wrapper 
	const launchModal = document.querySelectorAll('.launchModal');
	if (launchModal) {
		launchModal.forEach(function (item) {
			item.addEventListener('click', event => {
				const backdrop = document.querySelector('.modal-backdrop');
				const wrapper = document.getElementById('wrapper');
				wrapper.appendChild(backdrop);
			});
		});
	}



	// --------------  Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('click', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// ---------- Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	// for the search
	let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	popoverTriggerList.map(function (popoverTriggerEl) {
		return new Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});


	// ------------ Show modal flash by session
	const popUpFlash = document.getElementById('do_popin_flash');

	if (popUpFlash && popUpFlash.value == true) {
		setTimeout(function () {
			const modalFlashEl = document.getElementById('modal-flash');

			const modalFlash = new Modal(modalFlashEl, {
				keyboard: false,
				backdrop: false
			});

			const backdrop = new Backdrop({
				className: 'modal-backdrop',
				isVisible: true,
				isAnimated: true,
				rootElement: "#wrapper"
			})

			modalFlashEl.addEventListener('show.bs.modal', event => {
				backdrop.show();
			})

			modalFlashEl.addEventListener('hidden.bs.modal', event => {
				backdrop.hide();
			})

			modalFlash.show();
		}, 3000);
	}








	//  Match height for same size image in list  
	const match = new MatchHeight();
	match.reset();
	match.add('.list-horizontal .card-horizontal:not(.size--L)');

	const grid = document.querySelectorAll('.list-grid');
	let i = 0;
	grid.forEach(element => {
		i++;
		match.add(element.querySelectorAll('.card-vertical:not(.size--L)'), 'grid' + i);
	});

	const listVertical = document.querySelectorAll('.content-side-left .list-vertical');
	i = 0;
	listVertical.forEach(element => {
		i++;
		match.add(element.querySelectorAll('.card-vertical:not(.size--L)'), 'grid' + i);
	});

	






	let document_width = window.innerWidth;
	let document_height = window.height;

	window.addEventListener("resize", function () {
		// test pour éviter que le resize soit lancé au scroll sur mobile, lorsque l'adresse bar est cachée ou affichée

		


		if (document_width != window.innerWidth || document_height != window.height) {
			document_width = window.innerWidth;
			document_height = window.height;

			reportWindowSize();

			const myTimeout = setTimeout(function () {
				match.update();
				clearTimeout(myTimeout);
			}, 500); // caused by font-size reduction

		}
	});


});


// ---------  when page is resized ---------  //



let contentXL = 0;
if (document.querySelector('.home')) {
	contentXL = '.card-horizontal.size--L';
} else {
	contentXL = '.block-size-XL';
}

const sidebar = new sidebarItemPosition('#sidebar .sidebar-item', '.content-side-left', contentXL);

const pubSticky = new stickyScrollElement('#sidebar .sidebar-advertising', '.content-side-left');

const sideNavSticky = new stickyScrollElement('.social-bar-sticky', '.entry-content');




// --------- when page is fully loaded --------- //
window.addEventListener("load", function () {
	// a laisser dans le load, car si les images ne sont pas chargées les positions sont fausses ! 
	// console.log('load');

	sidebar.init();
	pubSticky.init();


	//  ---------- Appliquer sticky sur la social bar navigation dans les articles
	sideNavSticky.init();
	// ------- End social bar sticky 


	//  ---------- cache les sticky quand ils passent derriere des grands éléments 

	let largeElementsSocial = gsap.utils.toArray('.block-size-XL, .blockquote, .block-size-L');
	const socialBarHide = new hideSticky('.social-bar-sticky', largeElementsSocial);



	// if( document.querySelector('#sidebar .sidebar-advertising')) { 
	let largeElements = null;
	if (document.querySelector('.home')) {
		largeElements = gsap.utils.toArray('.card-horizontal.size--L');
	} else {
		largeElements = gsap.utils.toArray('.block-size-XL');
	}
	const pubHide = new hideSticky('#sidebar .sidebar-advertising', largeElements);



	socialBarHide.init();
	pubHide.init();




	// ------- End hide sticky

	// relance le positionnement de la sidebar , quand il y a les images qui se chargent ou changement dans le body ! 
	const resizeObserver = new ResizeObserver(() => {
		// console.log('mutation, launch again sidebar');
		pubSticky.delete(); // on supprime la position absoute en amont, pour que les items de la sidebar puissent se repositionner correctement, l'image etant en absolute, il n'y pas de hauteur pour l'élement 
		sidebar.delete();
		sidebar.init();
		pubSticky.init();
		ScrollTrigger.refresh();
	});



	const instafeed = document.querySelector("#instafeed");
	// voir avec arnaud pour simplifier, si il peut mettre directement l'image instagram ! initalement elle n'existe pas dans le dom
	if (instafeed) {
		resizeObserver.observe(instafeed);
	}

	// observer lazy load sur toutes les images de la sidebar
	const sidebarWrapper = document.querySelectorAll(".sidebar--wrapper img");
	if (sidebarWrapper.length > 0) {
		sidebarWrapper.forEach(element => {
			resizeObserver.observe(element);
		});
	}

});

